(() => {
  if (customElements.get('p-scrollwrap-table')) return;

  class PScrollwrapTable extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-sw-scroller]');
      this.scrollbar = this.querySelector('[data-sw-scrollbar]');
      this.thumb = this.querySelector('[data-sw-thumb]');
      this.prev_btn = this.querySelector('[data-sw-prev]');
      this.next_btn = this.querySelector('[data-sw-next]');
      if (!this.scroller || !this.scrollbar || !this.thumb || !this.prev_btn || !this.next_btn) return;

      this.columns = this.querySelectorAll('.p-sw-table__column');
      this.resize_timer = 0;
      this.scroll_raf = 0;
      this.bound_scroll = this.on_scroll.bind(this);
      this.bound_resize = this.on_resize.bind(this);
      this.bound_prev = this.scroll_by_column.bind(this, -1);
      this.bound_next = this.scroll_by_column.bind(this, 1);
      this.bound_block_select = this.on_block_select.bind(this);

      this.scroller.addEventListener('scroll', this.bound_scroll, { passive: true });
      this.prev_btn.addEventListener('click', this.bound_prev);
      this.next_btn.addEventListener('click', this.bound_next);
      window.addEventListener('resize', this.bound_resize, { passive: true });
      document.addEventListener('shopify:block:select', this.bound_block_select);
      this.update_thumb();
    }

    disconnectedCallback() {
      if (this.scroller && this.bound_scroll) {
        this.scroller.removeEventListener('scroll', this.bound_scroll);
      }
      if (this.prev_btn && this.bound_prev) {
        this.prev_btn.removeEventListener('click', this.bound_prev);
      }
      if (this.next_btn && this.bound_next) {
        this.next_btn.removeEventListener('click', this.bound_next);
      }
      window.removeEventListener('resize', this.bound_resize);
      document.removeEventListener('shopify:block:select', this.bound_block_select);
      if (this.resize_timer) window.clearTimeout(this.resize_timer);
      if (this.scroll_raf) window.cancelAnimationFrame(this.scroll_raf);
    }

    get_step_size() {
      if (this.columns.length >= 2) {
        const distance = this.columns[1].offsetLeft - this.columns[0].offsetLeft;
        if (distance > 0) return distance;
      }
      if (this.columns.length >= 1) {
        return this.columns[0].offsetWidth + 8;
      }
      return 100;
    }

    on_scroll() {
      if (this.scroll_raf) return;
      this.scroll_raf = window.requestAnimationFrame(() => {
        this.scroll_raf = 0;
        this.update_thumb();
      });
    }

    on_resize() {
      window.clearTimeout(this.resize_timer);
      this.resize_timer = window.setTimeout(() => this.update_thumb(), 120);
    }

    on_block_select(event) {
      if (!event.target || !this.contains(event.target)) return;
      const column = event.target.closest('.p-sw-table__column');
      if (!column) return;
      column.scrollIntoView({ behavior: this.get_scroll_behavior(), inline: 'nearest', block: 'nearest' });
    }

    update_thumb() {
      const max_scroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (max_scroll <= 0) {
        this.scrollbar.style.display = 'none';
        this.prev_btn.disabled = true;
        this.next_btn.disabled = true;
        return;
      }

      this.scrollbar.style.display = '';
      const current_scroll = Math.min(max_scroll, Math.max(0, this.scroller.scrollLeft));
      const fill = Math.min(1, (current_scroll + this.scroller.clientWidth) / this.scroller.scrollWidth);
      this.thumb.style.width = fill * 100 + '%';
      this.prev_btn.disabled = current_scroll <= 0;
      this.next_btn.disabled = current_scroll >= max_scroll - 1;
    }

    get_scroll_behavior() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'auto';
      return 'smooth';
    }

    scroll_by_column(direction) {
      const max_scroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      if (max_scroll <= 0) return;
      let target = this.scroller.scrollLeft + direction * this.get_step_size();
      if (target < 0) target = 0;
      if (target > max_scroll) target = max_scroll;
      this.scroller.scrollTo({ left: target, behavior: this.get_scroll_behavior() });
    }
  }

  customElements.define('p-scrollwrap-table', PScrollwrapTable);
})();
